import { render, staticRenderFns } from "./component.vue?vue&type=template&id=3559b67a&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3559b67a')) {
      api.createRecord('3559b67a', component.options)
    } else {
      api.reload('3559b67a', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=3559b67a&", function () {
      api.rerender('3559b67a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/secure/resource/component/cookies-banner/component.vue"
export default component.exports